import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Quanto tempo tenho acesso aos conteúdos?",
    answer: "Depende do plano! Mensal e anual durante o período contratado. Vitalício é pra sempre.",
  },
  {
    question: "O plano mensal tem acesso a todos os módulos?",
    answer: "Não. O plano mensal dá acesso apenas ao núcleo principal. Módulos de Corrida, Musculação, Nutrição e futuros são exclusivos para anual e vitalício.",
  },
  {
    question: "A Escape é pra qualquer idade?",
    answer: "É pra quem busca evolução real, independente da idade.",
  },
  {
    question: "Tem acompanhamento individual?",
    answer: "Não. É um projeto de desenvolvimento coletivo, dentro da comunidade.",
  },
  {
    question: "Posso migrar de plano?",
    answer: "Sim! Quem começa no mensal pode fazer upgrade para o anual ou vitalício a qualquer momento.",
  },
];

const FaqSection: React.FC = () => {
  return (
    <section className="section-container scroll-reveal" id="faq">
      <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center">
        DÚVIDAS FREQUENTES
      </h2>
      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border-white/20"
            >
              <AccordionTrigger className="text-lg font-medium">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-white/80">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
